import { getArticle as apiGetArticle, getArticleDirectLink as apiGetArticleDirectLink } from './get.article';
import { getArticleContent as apiGetArticleContent } from './get.article.content';
import { getArticles as apiGetArticles } from './get.articles';

export * from './search.articles';
export * from './get.pages';

export let getArticle = apiGetArticle;
export let getArticleContent = apiGetArticleContent;
export let getArticles = apiGetArticles;
export let getArticleDirectLink = apiGetArticleDirectLink;

export function setApi(api: {
    getArticle?: typeof getArticle;
    getArticleContent?: typeof getArticleContent;
    getArticles?: typeof getArticles;
    getArticleDirectLink?: typeof getArticleDirectLink;
}) {
    if (api.getArticle) {
        getArticle = api.getArticle;
    }
    if (api.getArticleContent) {
        getArticleContent = api.getArticleContent;
    }
    if (api.getArticles) {
        getArticles = api.getArticles;
    }
    if (api.getArticleDirectLink) {
        getArticleDirectLink = api.getArticleDirectLink;
    }
}
